import * as React from "react";
import {ApiManager} from "../../api/ApiManager";

interface ICurrentDateTimeContainerState {
    currentTime: number
}

interface ICurrentDateTimeContainerProps {
    children: any,
    pollTime?: number
}

class CurrentDateTimeContainer extends React.Component<ICurrentDateTimeContainerProps, ICurrentDateTimeContainerState> {
    state: ICurrentDateTimeContainerState = {
        currentTime: null
    };

    static defaultProps = {
        pollTime: 60000 // 1 minute
    };

    intervalId: number = null;

    getCurrentTimeFromServer = async () => {
        const currentTime = await ApiManager.getOrionApis().getCurrentTime();
        this.setState({currentTime: currentTime.data});
    };

    componentDidMount(): void {
        const { pollTime } = this.props;
        console.log("pollTime", pollTime);

        this.getCurrentTimeFromServer();
        this.intervalId = window.setInterval(() => {
            this.getCurrentTimeFromServer();
        }, pollTime);
    }

    componentWillUnmount(): void {
        if (this.intervalId) {
            window.clearInterval(this.intervalId)
        }
    }

    render() {
        const {currentTime} = this.state;
        return this.props.children(currentTime);
    }
}

export default CurrentDateTimeContainer;